import {
  CONVERTIBLE,
  LIMOUSINE,
  STATION_WAGON,
  SUV_PICKUP,
  VAN_TRANSPORTER,
  COUPE_SPORT,
  OTHER,
  BUS,
  CONVERTIBLE_COUPE,
  ROADSTER,
  SMALL_CAR,
  CHASSIS_CAB,
  PANEL_VAN_HIGH,
  PANEL_VAN_HIGH_LONG,
  PANEL_VAN_LONG,
  TRUCK_WITH_BOX_BODY,
  PLATFORM_CAB,
  OTHER_COMMERCIAL,
  TIPPER,
  PANEL_VAN,
} from './values';

export default {
  1006: BUS,
  1007: CONVERTIBLE,
  1008: COUPE_SPORT,
  1009: CONVERTIBLE_COUPE,
  1010: CHASSIS_CAB,
  1011: OTHER,
  1012: OTHER,
  1013: OTHER,
  1014: OTHER,
  1015: PANEL_VAN_HIGH_LONG,
  1016: PANEL_VAN_HIGH,
  1017: OTHER,
  1018: OTHER,
  1019: PANEL_VAN,
  1020: PANEL_VAN_LONG,
  1021: TIPPER,
  1022: TRUCK_WITH_BOX_BODY,
  1023: STATION_WAGON,
  1025: LIMOUSINE,
  1026: OTHER_COMMERCIAL,
  1027: SUV_PICKUP,
  1028: OTHER,
  1029: PLATFORM_CAB,
  1030: ROADSTER,
  1031: OTHER,
  1032: OTHER,
  1033: STATION_WAGON,
  1034: OTHER,
  1035: SUV_PICKUP,
  1036: OTHER,
  1037: OTHER,
  1038: VAN_TRANSPORTER,
  1165: OTHER,
  1166: OTHER,
  1167: OTHER,
  1168: OTHER,
  1169: OTHER,
  1171: OTHER,
  1172: OTHER,
  1173: OTHER,
  8111: SMALL_CAR,
};
